module.exports = __webpack_public_path__ + "media/icons/zmiana-wlasciciela-6328b1f7.png";